/* MUTATION TYPES
-------------------------------------------------------------- */
export const SET_CUSTOMER = 'SET_CUSTOMER';
